export const IIG_CTA = {
  ID: 1,
  buttonText: "Finish Payment",
  buttonFunc: "goToInternalPage:/user/updateField/86",
  backgroundColor: "#d1d7b6",
};
